export class ProductImageService {
  swap(source: HTMLImageElement | null, target: HTMLImageElement | null | undefined): void {
    if (!source || !target) {
      return;
    }

    const tempSrc: string = source.src;
    const tempAlt: string = source.alt;

    source.src = target.src;
    source.alt = target.alt;

    target.src = tempSrc;
    target.alt = tempAlt;
  }
}
